import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./resources/styles/index.css";
import { ContactFormApp } from "./main/ContactFormApp";
import { Spinner } from "spot-component-library/lib/components/basic/spinner/Spinner";
import "./i18n";
import { TenantProvider } from "./main/contexts/TenantContext";

const spinner = <Spinner isLoading={true} type="page" />;

ReactDOM.render(
    <React.StrictMode>
        <TenantProvider>
            <Suspense fallback={spinner}>
                <ContactFormApp />
            </Suspense>
        </TenantProvider>
    </React.StrictMode>,
    document.getElementById("contact-form")
);
